import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth";

export function useAuthFlow() {
  const router = useRouter();
  const authStore = useAuthStore();

  const resolveFlow = (res) => {
    if (!res?.data) {
      return { type: "error", reason: "invalid_response" };
    }

    const d = res.data;
    // نعتبر الرد ناجحاً إذا كان success true أو إذا كان الـ messageCode هو "00"
    const isSuccess = res.success || d.messageCode === "00" || d.success === true;

    // 🥇 1. REDIRECT (absolute priority)
    if (d.redirect_url) {
      return { type: "redirect", url: d.redirect_url };
    }

    // 🥈 2. AUTHENTICATED (absolute priority, check token presence)
    if (d.token) {
      return {
        type: "callback",
        token: d.token,
        user_status: d.user_status || 'existing' 
      };
    }

    // 🥉 3. OTP FLOW (Libya or explicit OTP)
    if (d.flow === "otp" || (isSuccess && !d.token && !d.redirect_url)) {
      return {
        type: "otp",
        // جلب الـ session من الـ data أو الـ data.success
        session: d.transaction_identify || d.success?.transaction_identify || null,
      };
    }

    // 🚨 EVERYTHING ELSE IS ERROR
    return { type: "error", reason: "unknown_flow", message: res.message || d.message };
  };

  const executeFlow = (flow, msisdn = null) => {
    switch (flow.type) {
      case "redirect":
        window.location.href = flow.url;
        return;
      case "callback":
        authStore.setToken(flow.token);
        localStorage.setItem("token", flow.token);
        localStorage.setItem("user_status", flow.user_status || "existing");
        if (msisdn) localStorage.setItem("msisdn", msisdn);
        router.push({
          name: "callback",
          query: router.currentRoute.value.query
        });
        return;
      case "otp":
        if (msisdn) localStorage.setItem("msisdn", msisdn);
        router.push({
          name: "otp",
          query: {
            ...router.currentRoute.value.query,
            msisdn,
            session: flow.session
          },
        });
        return;
      case "error":
        console.error("FLOW ERROR:", flow.reason);
        return;
    }
  };

  return { resolveFlow, executeFlow };
}
